import '@organisms/iframe-modal/iframe-modal';

import { defineElement, FC, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';

const MortgageToolRabo: FC = () => {
    const [raboUrl] = useProp<string>('raboUrl', '');

    return (
        <div class="c-mortgage-tool-rabo">
            <bpd-iframe-modal
                id="mortgage-tool-rabo"
                src={raboUrl}
                track-state
                no-padding
                use-css-dimensions
            />
        </div>
    );
};

MortgageToolRabo.props = {
    raboUrl: {
        type: String,
        reflectToAttr: true,
    },
    modalTitle: {
        type: String,
        reflectToAttr: true,
    },
};

defineElement('mortgage-tool-rabo', MortgageToolRabo);
